import {LegacyWBIcon} from '@wandb/weave/common/components/elements/LegacyWBIcon';
import NumberInput from '@wandb/weave/common/components/elements/NumberInput';
import React from 'react';
import {Button, Popup} from 'semantic-ui-react';
import styled from 'styled-components';

interface RangeInputProps {
  className?: string;
  minValue?: number;
  maxValue?: number;
  disabled?: boolean;
  stepper?: boolean;
  log?: boolean;
  logValue?: boolean;
  ignoreOutliers?: boolean;
  ignoreOutliersValue?: boolean;
  onMinChange?: (newVal?: number) => void;
  onMaxChange?: (newVal?: number) => void;
  onLogChange?: (newVal?: boolean) => void;
  onIgnoreOutliersChange?: (newVal?: boolean) => void;
}

const StyledRangeAndOptions = styled.div`
  display: flex;
  justify-content: flex-start;
  
  .number-input__container {
    margin-right: 0px; !important;
  }

  .number-input__input {
    margin-right: 0px !important;
  }

  .ui.button {
    margin-right: 0px;
  }

  > * + * {
    margin-left: 10px !important;
  }
`;

const RangeInput: React.FC<RangeInputProps> = props => {
  return (
    <StyledRangeAndOptions data-test="styled-range-and-options">
      <NumberInput
        disabled={props.disabled}
        stepper={false}
        placeholder="min"
        value={props.minValue}
        onChange={newVal => {
          props.onMinChange?.(newVal);
        }}
      />
      <NumberInput
        className="max"
        disabled={props.disabled}
        stepper={false}
        placeholder="max"
        value={props.maxValue}
        onChange={newVal => {
          props.onMaxChange?.(newVal);
        }}
      />
      {props.log && (
        <Popup
          on="hover"
          position="top center"
          content="Log scale"
          inverted
          size="mini"
          trigger={
            <Button
              disabled={props.disabled}
              toggle
              icon
              active={props.logValue}
              onClick={(e, {value}) => {
                if (props.onLogChange != null) {
                  props.onLogChange(!props.logValue);
                }
              }}>
              <LegacyWBIcon name="log" title="" />
            </Button>
          }
        />
      )}
      {props.ignoreOutliers && (
        <Popup
          inverted
          size="mini"
          on="hover"
          position="top center"
          content="Ignore outliers in chart scaling"
          trigger={
            <Button
              disabled={props.disabled}
              active={props.ignoreOutliersValue}
              icon
              toggle
              onClick={(e, {value}) => {
                if (props.onIgnoreOutliersChange != null) {
                  props.onIgnoreOutliersChange(!props.ignoreOutliersValue);
                }
              }}>
              <LegacyWBIcon
                name="outlier"
                title="Ignore outliers in chart scaling"
              />
            </Button>
          }
        />
      )}
    </StyledRangeAndOptions>
  );
};

export default RangeInput;
